import React, { useRef, useEffect, useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { handleGlobalDropdown2ValueInputChange } from '../store/table-slice';
import { alphanumericSort } from 'src/pages/analytics/simulator/innovation/utils/utils';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';

interface DropdownSubHeaderProps {
  columnData: Header;
  inputsDisabled?: boolean;
  pricingAction1Value: number;
  filteredSet2Options: any[];
  kpi1Fields?: string[];
}

const DropdownSubHeader: React.FC<DropdownSubHeaderProps> = ({
  columnData,
  inputsDisabled,
  pricingAction1Value,
  filteredSet2Options,
  kpi1Fields
}) => {
  const appDispatch = useAppDispatch();
  const { pricingAction2Value, tableMetadaData } = useAppSelector(
    (state) => state.table
  );
  const [value, setValue] = useState<any>(pricingAction2Value);
  const prevPricingAction1Value = useRef(pricingAction1Value);
  const handleValueChange = (e) => {
    setValue(e.target.value);
    appDispatch(
      handleGlobalDropdown2ValueInputChange({
        columnMetadata: columnData,
        newValue: e.target.value
      })
    );
  };
  useEffect(() => {
    if (prevPricingAction1Value.current !== pricingAction1Value) {
      // Reset the selection whenever pricingAction1Value changes
      setValue(''); // Reset the selection
      appDispatch(
        handleGlobalDropdown2ValueInputChange({
          columnMetadata: columnData,
          newValue: ''
        })
      ); // Dispatch an action to update the global state if needed
    }
    // prevPricingAction1Value.current = pricingAction1Value;
  }, [pricingAction1Value, columnData]);

  if (!columnData.parent.is_global_input_enable) return null;

  // Check if there are any KPI 1 fields configured
  const hasKPI1Fields = kpi1Fields && kpi1Fields.length > 0;

  // Check if ALL rows in the table have at least one KPI 1 field with a valid value
  const hasAnyKPI1Value =
    hasKPI1Fields &&
    tableMetadaData?.row?.length > 0 &&
    tableMetadaData.row.every((row) =>
      kpi1Fields.some((field) => {
        const fieldValue = row?.parent?.data?.[field];
        return (
          fieldValue !== null &&
          fieldValue !== undefined &&
          fieldValue !== 0 &&
          fieldValue !== '-' &&
          fieldValue !== ''
        );
      })
    );

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <Select
        value={value}
        onChange={handleValueChange}
        displayEmpty
        disabled={inputsDisabled || !hasAnyKPI1Value}
        inputProps={{ 'aria-label': 'Without label' }}
        style={{
          width: '120px',
          height: '30px',
          border: '1px solid transparent',
          textAlign: 'left',
          fontSize: '12px'
        }}
      >
        {alphanumericSort(filteredSet2Options).map((option, i) => (
          <MenuItem key={i} value={option.value} style={{ fontSize: '12px' }}>
            {option.alias}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropdownSubHeader;
